<div class="container-fluid">

  <app-client-list></app-client-list>
</div>